import GoogleAnalytics from 'react-ga';

/**
 * Logs an event to google analytics using firebase analytics instance
 * @param key - Key of the event
 * @param params - Extra parameters to an event
 */
export const logEvent = (category, action, label) => {
  if (category && action) {
    return GoogleAnalytics.event({
      category,
      action,
      label,
    });
  }
  return undefined;
};

export default {
  logEvent,
};



// WEBPACK FOOTER //
// ./src/helpers/analytics.js